import { get } from 'lodash';
import { FPTI, FPTI_SELL_PAGE_NAME } from './constants';

function defaultTracking(app) {
  return {
    custId: app.custId,
    pgrp: FPTI.pgrp,
    page: FPTI.pgrp
  };
}

function currentCategory(activeKey, categories) {
  // get the index of the current category
  let index = parseInt(activeKey, 10 /* base 10 */);
  if (isNaN(index)) {
    index = 0;
    // TODO log error message here
    // index means the index of the category tabs, -1 is favorites tab and 0 - N is categories
    // which is supposed to be a number but something happened
  }

  return (categories && get(categories[index], 'name', '')) || 'favorite';
}

function trackingOpts(app, activeKey, categories) {
  return {
    ...defaultTracking(app),
    page: `${FPTI.pgrp}::${currentCategory(activeKey, categories)}`
  };
}

function clickTrack(props = {}, opts = {}) {
  const { app, activeKey, categories, recordClick, tracking } = props;
  recordClick(tracking, {
    ...trackingOpts(app, activeKey, categories),
    ...opts
  });
}

function impressionTrack(props = {}, opts = {}) {
  const { app, activeKey, categories, recordImpression, tracking } = props;
  recordImpression(tracking, {
    ...trackingOpts(app, activeKey, categories),
    ...opts
  });
}

function clickTrackDetailPage(props = {}, partnerName, pos) {
  clickTrack(props, {
    page: `${FPTI_SELL_PAGE_NAME}:::${partnerName}`,
    pgrp: FPTI_SELL_PAGE_NAME,
    link: `${partnerName}_${pos}`
  });
}

function impressionTrackDetailPage(props = {}, partnerName) {
  impressionTrack(props, {
    page: `${FPTI_SELL_PAGE_NAME}:::${partnerName}`,
    pgrp: FPTI_SELL_PAGE_NAME
  });
}

function impressionTrackManual(props = {}, opts = {}) {
  const { app, activeKey, categories } = props;
  window.PAYPAL.analytics.Analytics.prototype.recordImpression(null, {
    ...trackingOpts(app, activeKey, categories),
    ...opts
  });
}

export {
  defaultTracking,
  currentCategory,
  trackingOpts,
  clickTrack,
  impressionTrack,
  clickTrackDetailPage,
  impressionTrackDetailPage,
  impressionTrackManual
};
